import React from 'react';
import './styles/reduction.scss';

import { Provider } from 'react-redux';
import store from './store';
import Routes from './components/common/Routes';
import { loadUser } from './actions/auth';

class App extends React.Component {
  componentDidMount(){
    store.dispatch(loadUser())
  }

  render() {
    return (
      <Provider store={store}>
        <Routes/>
      </Provider>
    );
  }
}


export default App;
